/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { PRODUCTOS } from "utils/constants";
import MiPerfilPopover from "./MiPerfilPopover";
import NavItemLink from "./NavItemLink";
import "./publicNavbar.scss";
import PublicSideBar from "./publicSideBar";
import ImgLogo from "assets/img/logo/logo-page2.png";
import { useLocation } from "react-router";
const PublicNavbar = (props) => {
  const { userIsLoggedIn } = useSelector(
    (state) => state.datosUsuarios.dataUsuario
  );
  const [showLogo, setshowLogo] = useState(false);

  const location = useLocation();

  const showLogoAIG = () => {
    if (
      location.pathname.includes("/kids/") &&
      location.pathname.includes("kids")
    ) {
      setshowLogo(true);
    } else {
      setshowLogo(false);
    }
  };
  useEffect(() => {
    showLogoAIG();
  }, [location]);

  return (
    <nav className="d-flex flex-row nav__container justify-content-between">
      <ul className="d-none d-lg-flex flex-row list-unstyled h-100 align-items-center">
        {showLogo && (
          <NavItemLink
            title={
              <img
                src={ImgLogo}
                className="img-logo-segukids"
                alt=""
                loading="lazy"
              />
            }
            path="/"
            {...props}
            tabName="logo"
          />
        )}
        <NavItemLink
          title="Personas"
          path="/"
          {...props}
          tabName="personas"
          productos={[PRODUCTOS.APINDIVIDUAL, PRODUCTOS.HOGAR]}
        />
        <NavItemLink
          title="Empresas"
          path="/empresas"
          {...props}
          tabName="empresas"
          productos={[
            PRODUCTOS.TRAVELBTA,
            PRODUCTOS.PYMES,
            PRODUCTOS.pymesAbiertoInd,
            PRODUCTOS.LINEAS_FINANCIERAS,
          ]}
        />
      </ul>

      <ul className="list-unstyled d-flex flex-row w-100 justify-content-between h-100">
        <li className="nav__item__sidebar__button">
          <PublicSideBar />
        </li>

        {userIsLoggedIn && (
          <React.Fragment>
            <MiPerfilPopover />
          </React.Fragment>
        )}

        {!userIsLoggedIn && (
          <React.Fragment>
            <div className="ml-auto d-none d-lg-flex flex-row">
              <li
                className="nav__item__border_rigth__default nav__font__source__sans__pro nav__text__style h-100"
                style={{ width: "200px", paddingTop: "20px" }}
              >
                <Link
                  to="/login?user=clientes"
                  className="my-auto h-100"
                  id="link-soy-cliente-login"
                >
                  SOY CLIENTE
                </Link>
              </li>

              <li
                className="nav__item__border_rigth__default nav__font__source__sans__pro nav__text__style text-center"
                style={{ width: "250px", paddingTop: "20px" }}
              >
                <Link to="/login?user=agentes">SOY AGENTE O BROKER</Link>
              </li>
            </div>
          </React.Fragment>
        )}
      </ul>
    </nav>
  );
};

export default PublicNavbar;

/*
   <div
      style={{
        display: 'flex',
        width: '100%',
      }}
    >
      <nav
        className="text-white mb-5"
        style={{
          width: '100%',
          backgroundColor: '#001871',
          height: '71px',
          display: 'block',
        }}
      >
        <ul
          style={{
            width: '100%',
            height: '71px',
            margin: '0',
            padding: '0',
          }}
        >
          <li
            style={{
              height: '71px',
              display: 'inline',
              float: 'left',
              padding: '23px 0',
            }}
          >
            <a
              href="#"
              style={{
                fontFamily: 'Futura Bold',
                color: 'white',
                textDecoration: 'none',
                padding: '26px 35.5px 30px',
                borderRight: '1px solid rgba(255, 255, 255, 0.5)',
              }}
            >
              Personas
            </a>
          </li>
        </ul>
      </nav>
    </div>
  
*/
